import React from 'react';
import { CheckIcon, MonitorIcon, BookOpenIcon, GiftIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full py-20 px-4 bg-brand-bg" data-id="element-119">
      <div className="max-w-3xl mx-auto space-y-12" data-id="element-120">
        {/* What is BetIQ */}
        <div className="space-y-4 text-center" data-id="element-121">
          <h2 className="text-3xl md:text-4xl text-brand-gold font-bold" data-id="element-122">
            ¿Qué es BetIQ?
          </h2>
          <p className="text-lg text-brand-muted max-w-2xl mx-auto" data-id="element-123">
            BetIQ es una plataforma digital a la que accedes desde tu celular o
            computadora, donde puedes analizar partidos y tomar mejores
            decisiones al apostar.
          </p>
          <p className="text-base text-brand-muted max-w-2xl mx-auto" data-id="element-124">
            No es una app complicada ni un grupo de señales. Es un sistema
            simple que puedes usar paso a paso.
          </p>
        </div>

        {/* What's included */}
        <div className="bg-brand-card border border-brand-gold/20 rounded-2xl p-8 space-y-5" data-id="element-125">
          <h3 className="text-2xl text-brand-text font-bold text-center" data-id="element-126">
            ¿Qué incluye?
          </h3>
          <p className="text-brand-muted text-center" data-id="element-127">
            Al realizar tu compra, recibes acceso inmediato a:
          </p>
          <ul className="space-y-4 max-w-md mx-auto" data-id="element-128">
            <li className="flex items-center gap-3" data-id="element-129">
              <MonitorIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-130" />
              <span className="text-brand-text" data-id="element-131">
                La plataforma BetIQ (usuario y contraseña)
              </span>
            </li>
            <li className="flex items-center gap-3" data-id="element-132">
              <BookOpenIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-133" />
              <span className="text-brand-text" data-id="element-134">
                El método paso a paso en formato PDF
              </span>
            </li>
            <li className="flex items-center gap-3" data-id="element-135">
              <GiftIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-136" />
              <span className="text-brand-text" data-id="element-137">Los bonos incluidos</span>
            </li>
          </ul>
        </div>

        {/* How to use */}
        <div className="text-center space-y-3" data-id="element-138">
          <h3 className="text-2xl text-brand-text font-bold" data-id="element-139">¿Cómo se usa?</h3>
          <p className="text-brand-muted text-lg max-w-xl mx-auto" data-id="element-140">
            Primero aprendes el método. Luego utilizas la plataforma BetIQ para
            aplicar ese análisis en partidos reales.
          </p>
        </div>

        {/* Closing statement */}
        <div className="text-center border-t border-brand-gold/15 pt-10 space-y-2" data-id="element-141">
          <p className="text-xl md:text-2xl text-brand-text font-bold" data-id="element-142">
            No estás comprando solo información.
          </p>
          <p className="text-lg text-brand-gold" data-id="element-143">
            Estás accediendo a un sistema completo para entender y mejorar tus
            decisiones al apostar.
          </p>
        </div>
      </div>
    </section>;
}